module.exports = __webpack_public_path__ + "static/graph-3_fr-d0e08da3a46f678215140dfcb69347d3.svg";